import React from 'react';
import CustomerVehicles from '../components/fleet/CustomerVehicles';

const FleetCustomers: React.FC = () => {
  return <CustomerVehicles />;
};

export default FleetCustomers;
